import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class RoadmapIndexRoute extends Route {
  @service router;

  beforeModel(/* transition */) {
    this.router.transitionTo('roadmap.strategy'); // Implicitly aborts the on-going transition.
  }
}
